<style lang="stylus">

    .notify-container
      position fixed
      right -310px
      top $common-box-top
      width 310px
      background #fff;
      box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.05), 0px 4px 10px rgba(0, 0, 0, 0.08);
      border: 1px solid $box-bordercolor;
      height 100%
      z-index 11
      -webkit-transition right 1s ease
      -moz-transition right 1s ease
      transition right 0.3s ease
      .header
        padding 12px 16px 12px 24px
        border-bottom 1px solid $box-bordercolor
        display flex
        justify-content space-between
        align-items center
        background #fff
        width 100%
        z-index 1
        span
          font-weight bold
          font-size 14px
          line-height 24px
          color #333333
        svg
          width 16px
          height 16px
          cursor pointer
          &.disable
            cursor not-allowed
      .content
        width 100%
        height calc(100% - 53px)
        overflow-y scroll
        overflow overlay
        &::-webkit-scrollbar
          width 6px
        &::-webkit-scrollbar-thumb
            background rgba(0, 0, 0, 0.1)
            -webkit-box-shadow inset006pxrgba(0,0,0,0.5)
            border-radius 4px
        &::-webkit-scrollbar-track
            -webkit-box-shadow inset006pxrgba(0,0,0,0.3)
            border-radius 4px
        .content-item-list
          border-bottom 1px solid rgba(0,0,0,0.05)
          &:last-child
            padding-bottom 20px
          .content-item
            padding 32px 16px 32px 24px
            font-size 12px
            line-height 16px
            a
              word-break break-word
            &:hover{
              background-color: $main-hovercolor;
            }
            &:active
              background $main-selectcolor
            .content-item-header
              display flex
              justify-content space-between
              align-items center
              margin-bottom 8px
              color #333333
              position relative
            .unread-tip
              &::after
                content ''
                width 6px
                height 6px
                background-color #F24822
                border-radius 50%
                position absolute
                top 0
                left -6px
            .content-item-title
              font-weight 600
            .content-item-time
              color #999999
</style>

<template>
    <div class="notify-container" v-if="!isPC" :style="{ right: !!showUserNotifyMsg ? '0px' : '-310px' }" @click.stop="() => {}">
        <div class="header">
            <span>{{ $t("myMsg") }}</span>
            <div @click.stop="changeAllRead()" title="全部已读">
                <iconSymbol v-if="allIsRead" class="disable" name="read-all-notifiedmsg-disable" />
                <iconSymbol v-else name="read-all-notifiedmsg" />
            </div>
        </div>
        <div class="content" ref="content" @scroll="handleScroll">
            <div class="content-item-list" v-for="item in NotifyMsgArr" :key="item.id">
                <div class="content-item" :class="{ active: activeIndex == item.id }" @click.stop="setIsRead(item.id)">
                    <div class="content-item-header">
                        <div class="content-item-title" :class="{ 'unread-tip': !item.is_read }">
                            {{ item.type == "system" ? `【${$t("systemMsg")}】` : `【${$t("otherMsg")}】` }}
                        </div>
                        <span class="content-item-time">{{ item.created_at.split(" ")[0] }}</span>
                    </div>
                    <div class="content-item-text" @click="openLink($event)">
                        <div v-html="addATag(item.content)"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {},
    })
    export default class Base extends Vue {
        // arr:Array<any> = [
        //     {
        //         "id": 2310412,
        //         "sender_id": 27055,
        //         "sender_type": "admin",
        //         "action": "send",
        //         "target_id": 0,
        //         "target_type": "",
        //         "type": "system",
        //         "content": "【购买成功通知】<br>您好！您的亿图图示和亿图脑图MindMaster终身会员开通成功。<br>请于2021年12月31日前领取以下赠品，过期失效：<br>亿图项目管理兑换如下：<br>【亿图项目管理兑换说明】https://www.edrawsoft.cn/project-activation/<br>亿图项目管理1年会员的兑换码是：RA-mz0eQytLTu <br>Pixso和BoardMix 专业版目前限时免费体验，专业版权益将会在产品收费后兑换。请点击链接注册/登录账户，领取6个月专业版权益>>>https://pixso.cn/app/explore?orderId=2373222820211216102348573 <br>笔记本领取链接：https://wj.qq.com/s2/9433122/9c2e/<br>如有疑问请联系公众号客服：亿图软件<br>",
        //         "is_read": 0,
        //         "receiver_id": 23732228,
        //         "created_at": "2021-12-16 10:23:56"
        //     },
        //     {
        //         "id": 2299235,
        //         "sender_id": 27055,
        //         "sender_type": "admin",
        //         "action": "send",
        //         "target_id": 0,
        //         "target_type": "",
        //         "type": "system",
        //         "content": "【购买成功通知】<br>您好！您的亿图图示和亿图脑图MindMaster终身会员开通成功。<br>请于2021年12月31日前领取以下赠品，过期失效：<br>亿图项目管理兑换如下：<br>【亿图项目管理兑换说明】https://www.edrawsoft.cn/project-activation/<br>亿图项目管理1年会员的兑换码是：RA-BqbT2WM0kq <br>Pixso和BoardMix 专业版目前限时免费体验，专业版权益将会在产品收费后兑换。请点击链接注册/登录账户，领取6个月专业版权益>>>https://pixso.cn/app/explore?orderId=2373222820211214104513164 <br>笔记本领取链接：https://wj.qq.com/s2/9433122/9c2e/<br>如有疑问请联系公众号客服：亿图软件<br>",
        //         "is_read": 1,
        //         "receiver_id": 23732228,
        //         "created_at": "2021-12-14 10:45:22"
        //     },
        //     {
        //         "id": 2293826,
        //         "sender_id": 27055,
        //         "sender_type": "admin",
        //         "action": "send",
        //         "target_id": 0,
        //         "target_type": "",
        //         "type": "system",
        //         "content": "【购买成功通知】<br>您好！您的MindMaster和亿图图示会员已开通成功。亿图项目管理软件（1年授权）需激活开通，您的激活码是： RA-Sk4dvOGae4 <br>【亿图项目管理软件激活说明】<br> <a href=\"https://www.edrawsoft.cn/project-activation/\">https://www.edrawsoft.cn/project-activation/</a> <br> 如有疑问请联系公众号客服：亿图软件",
        //         "is_read": 1,
        //         "receiver_id": 23732228,
        //         "created_at": "2021-12-13 14:58:51"
        //     },
        //     {
        //         "id": 2293449,
        //         "sender_id": 27055,
        //         "sender_type": "admin",
        //         "action": "send",
        //         "target_id": 0,
        //         "target_type": "",
        //         "type": "system",
        //         "content": "【购买成功通知】<br>您好！您的亿图图示和亿图脑图MindMaster终身会员开通成功。<br>请于2021年12月31日前领取以下赠品，过期失效：<br>亿图项目管理兑换如下：<br>【亿图项目管理兑换说明】https://www.edrawsoft.cn/project-activation/<br>亿图项目管理1年会员的兑换码是：RA-1yknGcNU21 <br>Pixso和BoardMix 专业版目前限时免费体验，专业版权益将会在产品收费后兑换。请点击链接注册/登录账户，领取6个月专业版权益>>>https://pixso.cn/app/explore?orderId=2373222820211213141826137 <br>笔记本领取链接：https://wj.qq.com/s2/9433122/9c2e/<br>如有疑问请联系公众号客服：亿图软件<br>",
        //         "is_read": 1,
        //         "receiver_id": 23732228,
        //         "created_at": "2021-12-13 14:18:35"
        //     },
        //     {
        //         "id": 2293256,
        //         "sender_id": 27055,
        //         "sender_type": "admin",
        //         "action": "send",
        //         "target_id": 0,
        //         "target_type": "",
        //         "type": "system",
        //         "content": "【购买成功通知】<br>您好！您的MindMaster和亿图图示会员已开通成功。亿图项目管理软件（1年授权）需激活开通，您的激活码是： RA-p1QH1onxBj <br>【亿图项目管理软件激活说明】<br> <a href=\"https://www.edrawsoft.cn/project-activation/\">https://www.edrawsoft.cn/project-activation/</a> <br> 如有疑问请联系公众号客服：亿图软件",
        //         "is_read": 1,
        //         "receiver_id": 23732228,
        //         "created_at": "2021-12-13 13:47:53"
        //     },
        //     {
        //         "id": 2292759,
        //         "sender_id": 27055,
        //         "sender_type": "admin",
        //         "action": "send",
        //         "target_id": 0,
        //         "target_type": "",
        //         "type": "system",
        //         "content": "【购买成功通知】<br>您好！您的亿图图示终身会员开通成功。<br>MindMaster6个月会员已充值到该账号。<br>Pixso和BoardMix6个月会员将会在产品收费后统一充值到账，请前往官网注册账户后，在表单中准确填写账户信息，届时将会有短信通知：https://wj.qq.com/s2/9357639/fc95/<br>如有疑问请联系公众号客服：亿图软件<br>",
        //         "is_read": 1,
        //         "receiver_id": 23732228,
        //         "created_at": "2021-12-13 11:55:12"
        //     },
        //     {
        //         "id": 2292404,
        //         "sender_id": 27055,
        //         "sender_type": "admin",
        //         "action": "send",
        //         "target_id": 0,
        //         "target_type": "",
        //         "type": "system",
        //         "content": "【购买成功通知】<br>您好！您的亿图图示和亿图脑图MindMaster终身会员开通成功。<br>请于2021年12月31日前领取以下赠品，过期失效：<br>亿图项目管理兑换如下：<br>【亿图项目管理兑换说明】https://www.edrawsoft.cn/project-activation/<br>亿图项目管理1年会员的兑换码是：RA-kYooUjWy6O <br>Pixso和BoardMix 专业版目前限时免费体验，专业版权益将会在产品收费后兑换。请点击链接注册/登录账户，领取6个月专业版权益>>>https://pixso.cn/app/explore?orderId=2373222820211213105807501 <br>笔记本领取链接：https://wj.qq.com/s2/9433122/9c2e/<br>如有疑问请联系公众号客服：亿图软件<br>",
        //         "is_read": 1,
        //         "receiver_id": 23732228,
        //         "created_at": "2021-12-13 10:58:23"
        //     },
        //     {
        //         "id": 2292147,
        //         "sender_id": 27055,
        //         "sender_type": "admin",
        //         "action": "send",
        //         "target_id": 0,
        //         "target_type": "",
        //         "type": "system",
        //         "content": "【购买成功通知】<br>您好！您的亿图图示和亿图脑图MindMaster终身会员开通成功。<br>请于2021年12月31日前领取以下赠品，过期失效：<br>亿图项目管理兑换如下：<br>【亿图项目管理兑换说明】https://www.edrawsoft.cn/project-activation/<br>亿图项目管理1年会员的兑换码是：RA-1jCOwE8Gwr <br>Pixso和BoardMix 专业版目前限时免费体验，专业版权益将会在产品收费后兑换。请点击链接注册/登录账户，领取6个月专业版权益>>>https://pixso.cn/app/explore?orderId=2373222820211213103102909 <br>笔记本领取链接：https://wj.qq.com/s2/9433122/9c2e/<br>如有疑问请联系公众号客服：亿图软件<br>",
        //         "is_read": 1,
        //         "receiver_id": 23732228,
        //         "created_at": "2021-12-13 10:31:18"
        //     },
        //     {
        //         "id": 2284418,
        //         "sender_id": 27055,
        //         "sender_type": "admin",
        //         "action": "send",
        //         "target_id": 0,
        //         "target_type": "",
        //         "type": "system",
        //         "content": "【购买成功通知】<br>您好！您的亿图图示和亿图脑图MindMaster终身会员开通成功。<br>请于2021年12月31日前领取以下赠品，过期失效：<br>亿图项目管理兑换如下：<br>【亿图项目管理兑换说明】https://www.edrawsoft.cn/project-activation/<br>亿图项目管理1年会员的兑换码是：RA-ojm82bGWNq <br>Pixso和BoardMix 专业版目前限时免费体验，专业版权益将会在产品收费后兑换。请点击链接注册/登录账户，领取6个月专业版权益>>>https://pixso.cn/app/explore?orderId=2373222820211211182223924 <br>笔记本领取链接：https://wj.qq.com/s2/9433122/9c2e/<br>如有疑问请联系公众号客服：亿图软件<br>",
        //         "is_read": 1,
        //         "receiver_id": 23732228,
        //         "created_at": "2021-12-11 18:22:40"
        //     },
        //     {
        //         "id": 2283799,
        //         "sender_id": 27055,
        //         "sender_type": "admin",
        //         "action": "send",
        //         "target_id": 0,
        //         "target_type": "",
        //         "type": "system",
        //         "content": "【购买成功通知】<br>您好！您的亿图图示终身会员开通成功。<br>MindMaster6个月会员已充值到该账号。<br>Pixso和BoardMix6个月会员将会在产品收费后统一充值到账，请前往官网注册账户后，在表单中准确填写账户信息，届时将会有短信通知：https://wj.qq.com/s2/9357639/fc95/<br>如有疑问请联系公众号客服：亿图软件<br>",
        //         "is_read": 1,
        //         "receiver_id": 23732228,
        //         "created_at": "2021-12-11 16:28:46"
        //     },

        // ]
        activeIndex: number = -1;
        fixHeader: boolean = false;
        get userInfo() {
            return this.$store.state.userInfo;
        }
        get NotifyMsgArr() {
            return this.$store.state.userNotifyMsg.NotifyMsgArr;
        }

        get allIsRead() {
            return this.$store.state.userNotifyMsg.allIsRead;
        }

        get showUserNotifyMsg() {
            return this.$store.state.userNotifyMsg.showUserNotifyMsg;
        }

        changeAllRead() {
            let uObj = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
            };
            let unReadList = this.NotifyMsgArr.filter((v, k) => {
                return v.is_read == 0;
            });
            let ids = unReadList.map((v) => v.id);
            // this.arr.forEach((item)=>{
            //   item.is_read = 1;
            // })
            if (ids.length > 0) {
                this.$store.dispatch("userNotifyMsg/setIsRead", { ...uObj, ids, all: true });
            }
        }
        setIsRead(id) {
            this.activeIndex = id;
            let ids = [];
            ids.push(id);
            let uObj = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
            };
            this.$store.dispatch("userNotifyMsg/setIsRead", { ...uObj, ids });
        }
        openLink(e: any) {
            if (e.target.tagName == "A") {
                let url = e.target.getAttribute("data-url");
                window.open(url);
            }
        }
        addATag(b: any) {
            let data = "";
            if (/\<\/a\>/.test(b)) {
                // 已有a标签特殊处理
                let tempUrl = b.match(/(http[s]*:\/\/[\w.\/\-\?\&\=]+)/gi)[0];
                data = b.replace(/href=("[^"]+")|('[^']+')/g, 'href="javascript:void(0);" data-url=' + tempUrl);
            } else {
                let a = /(http[s]*:\/\/[\w.\/\-\?\&\=]+)(?![^<]+>)/gi;
                data = b.replace(a, "<a href='javascript:void(0);' data-url='$1'>$1</a>");
            }
            return data;
        }

        handleScroll() {
            const scrollTop = (this.$refs.content as any).scrollTop;
            const offsetHeight = (this.$refs.content as any).offsetHeight;
            const scrollHeight = (this.$refs.content as any).scrollHeight;
            if (offsetHeight + scrollTop - scrollHeight >= -1) {
                //请求数据接口
                let uObj = {
                    id: this.userInfo.user_id,
                    token: this.userInfo.token,
                };
                this.$store.dispatch("userNotifyMsg/getNotifiedMsg", { ...uObj, offset: 0, count: Math.pow(10, 10) });
                return false;
            }
        }
        //生命周期
        mounted() {}

        created() {}
    }
</script>

<i18n>
{
  "zh": {
    "myMsg": "我的消息",
    "systemMsg": "系统消息",
    "otherMsg": "其他消息"
  },
  "de": {
    "myMsg": "Meine Nachrichten",
    "systemMsg": "Systemnachrichten",
    "otherMsg": "Andere Nachrichten"
  },
  "fr": {
    "myMsg": "Mes Messages",
    "systemMsg": "Messages système",
    "otherMsg": "Autres Messages"
  },
  "es": {
    "myMsg": "Mis Mensajes",
    "systemMsg": "Mensajes del Sistema",
    "otherMsg": "Otros Mensajes"
  },
  "jp": {
    "myMsg": "メッセージ",
    "systemMsg": "システムメッセージ",
    "otherMsg": "その他のメッセージ"
  },
  "en": {
    "myMsg": "My Messages",
    "systemMsg": "System Messages",
    "otherMsg": "Other Messages"
  },
  "tw": {
    "myMsg": "我的消息",
    "systemMsg": "系統訊息",
    "otherMsg": "其它訊息"
  },
  "it": {
    "myMsg": "I Miei Messaggi",
    "systemMsg": "Messaggi di Sistema",
    "otherMsg": "Altri Messaggi"
  },
  "pt": {
    "myMsg": "Minhas Mensagens",
    "systemMsg": "Mensagens do Sistema",
    "otherMsg": "Outras Mensagens"
  },
  "kr": {
    "myMsg": "내 메시지",
    "systemMsg": "시스템 메시지",
    "otherMsg": "기타 메시지"
  },
  "id": {
    "myMsg": "Pesan Saya",
    "systemMsg": "Pesan Sistem",
    "otherMsg": "Pesan Lain"
  }
}
</i18n>
